export default __webpack_public_path__ + "static/media/IconDesc_Stator.256.5672f6bd.png";